import type { Platform } from "./resolvePlatform";
import type { ThemeConfig } from "./types";

/** Temporary mocks until backend theme endpoint and DB model exist. */
const themeMocks: Record<Platform, ThemeConfig> = {
  glofox: {
    platform: "glofox",
    tokens: {
      primary: "#0066CC",
      background: "#F5F7FA",
      text: "#1A1A2E",
    },
  },
};

export function getThemeMock(platform: Platform): ThemeConfig {
  return themeMocks[platform];
}
